<section id="inicio" class="hero section">
	<div class="container hero-layout">
		<div class="hero-content hero-copy">
			<span class="pill">Sistema de gestión general multi-rubro basado en la nube</span>
			<h1>Gestioná clientes, presupuestos, reparaciones y cobros desde una sola plataforma profesional</h1>
			<p class="subtitle">
				Con NETiC centralizá presupuestos, reparaciones, seguimiento de equipos, pagos y
				tablero operativo para negocios que necesitan más control y una gestión más profesional.
			</p>
			<p class="trial-text">Empezá hoy con tu primer mes gratis y llevá tu negocio a otro nivel.</p>
			<div class="hero-cta">
				<a class="btn" href="#cta-final">Probar gratis</a>
				<a class="btn btn-ghost hero-planes-cta" href="#planes">Ver planes</a>
			</div>
		</div>

		<div class="hero-visual">
			<div class="hero-panel hero-panel-main">
				<div class="panel-head">
					<div>
						<p class="panel-eyebrow">Panel de control</p>
					</div>
					<span class="status-pill">Primer mes gratis</span>
				</div>
				<div class="hero-metrics">
					<div class="hero-metric">
						<strong>7 días</strong>
						<span>Último período analizado</span>
					</div>
					<div class="hero-metric">
						<strong>$ 2,4M</strong>
						<span>Facturado / cobrado</span>
					</div>
					<div class="hero-metric">
						<strong>4 rubros</strong>
						<span>Clasificación de ingresos</span>
					</div>
				</div>
				<div class="hero-list">
					<div class="hero-list-row">
						<span class="dot success"></span>
						<div>
							<strong>Presupuesto generado</strong>
							<p>Cliente, articulo y condiciones vinculadas</p>
						</div>
						<!--<small>Listo</small> -->
					</div>
					<div class="hero-list-row">
						<span class="dot info"></span>
						<div>
							<strong>Reparación asociada a equipo</strong>
							<p>Seguimiento técnico y estado de avance</p>
						</div>
						<!--<small>En proceso</small> --> 
					</div>
					<div class="hero-list-row">
						<span class="dot warning"></span>
						<div>
							<strong>Recibo emitido</strong>
							<p>Cobro registrado e imputado al cliente</p>
						</div>
						<!--<small>Sincronizado</small> -->
					</div>
				</div>
			</div>

			<div class="hero-panel hero-panel-side">
				<p class="panel-eyebrow">Módulos disponibles</p>
				<div class="hero-chip-cloud">
					<span class="hero-chip">Dashboard</span>
					<span class="hero-chip">Clientes y proveedores</span>
					<span class="hero-chip">Presupuestos</span>
					<span class="hero-chip">Recibos</span>
					<span class="hero-chip">Artículos</span>
					<span class="hero-chip">Localidades</span>
					<span class="hero-chip">Equipos</span>
					<span class="hero-chip">Reparaciones</span>
					<span class="hero-chip">Inventario</span>
					<span class="hero-chip">Reportes y graficos</span>
				</div>
			</div>
		</div>
	</div>
</section>

<section id="galeria" class="section section-light gallery-section">
	<div class="container">
		<div class="section-header">
			<h2 class="panel-eyebrow">Galería de imágenes del sistema NETiC</h2>
			<p class="section-lead">Recorré algunas pantallas del sistema NETiC para ver cómo se visualiza el flujo de
				trabajo y la gestión.</p>
		</div>
		<div class="hero-panel hero-carousel-panel gallery-carousel">
			<div class="carousel-panel-head">
				<div class="carousel-controls">
					<button type="button" aria-label="Anterior" (click)="prevImage()">‹</button>
					<button type="button" aria-label="Siguiente" (click)="nextImage()">›</button>
				</div>
			</div>
			<div class="carousel-frame">
				<img [src]="currentImage" alt="Vista del sistema NETiC" />
			</div>
			<div class="carousel-dots">
				<button type="button" *ngFor="let image of carouselImages; let i = index"
					[class.active]="i === activeIndex" (click)="goTo(i)" aria-label="Slide {{ i + 1 }}"></button>
			</div>
		</div>
	</div>
</section>